// hospitalTypeSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IHospitalType, IHospitalTypeInitialState } from "./hospitalTypeModal";
import {
  activeInactiveHospitalType,
  createHospitalType,
  deleteHospitalType,
  getAllActiveHospitalTypes,
  getAllHospitalTypes,
  getHospitalTypeByID,
  updateHospitalType,
} from "./services/hospitalType.service";

const initialState: IHospitalTypeInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  HospitalTypeID: null,
  HospitalTypeList: [],
  HospitalTypeDetail: {
    ID: null,
    Title: "",
    IsActive: 1,
  },
};

const hospitalTypeSlice = createSlice({
  name: "hospitalType",
  initialState,
  reducers: {
    clearHospitalTypeDetails: (state) => {
      state.HospitalTypeDetail = initialState.HospitalTypeDetail;
    },
    setHospitalTypeID: (state, action) => {
      state.HospitalTypeID = action.payload;
    },
    clearHospitalTypeID: (state) => {
      state.HospitalTypeID = initialState.HospitalTypeID;
    },
  },
  extraReducers: (builder) => {
    // Get All Hospital Types
    builder.addCase(getAllHospitalTypes.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllHospitalTypes.fulfilled,
      (state, action: PayloadAction<IHospitalType[]>) => {
        state.loading = false;
        state.HospitalTypeList = action.payload || [];
      },
    );
    builder.addCase(getAllHospitalTypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.HospitalTypeList = [];
    });

    // Create Hospital Type
    builder.addCase(createHospitalType.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createHospitalType.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createHospitalType.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Update Hospital Type
    builder.addCase(updateHospitalType.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateHospitalType.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateHospitalType.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Delete Hospital Type
    builder.addCase(deleteHospitalType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteHospitalType.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteHospitalType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Get Hospital Type By ID
    builder.addCase(getHospitalTypeByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getHospitalTypeByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.HospitalTypeDetail = action.payload;
    });
    builder.addCase(getHospitalTypeByID.rejected, (state, action) => {
      state.formLoading = false;
      state.HospitalTypeDetail = initialState.HospitalTypeDetail;
      state.error = action.error.message || "Something went wrong";
    });

    // Get All Active Hospital Types
    builder.addCase(getAllActiveHospitalTypes.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveHospitalTypes.fulfilled,
      (state, action: PayloadAction<IHospitalType[]>) => {
        state.loading = false;
        state.HospitalTypeList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveHospitalTypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.HospitalTypeList = [];
    });

    // Active/Inactive Hospital Type
    builder.addCase(activeInactiveHospitalType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(activeInactiveHospitalType.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(activeInactiveHospitalType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearHospitalTypeDetails,
  clearHospitalTypeID,
  setHospitalTypeID,
} = hospitalTypeSlice.actions;
export default hospitalTypeSlice.reducer;
